import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  CreateElectricalMeasurementDetailPage,
} from '../../pages/global/create-electrical-measurement/create-electrical-measurement-detail/create-electrical-measurement-detail.page';
import { LoggerService } from '../../ax-commons-logger/logger/logger.service';
import { Observable } from 'rxjs';
import { AppState } from '../../ngxs/app/app.state';
import { Store } from '@ngxs/store';
import { RolesEnum, RolesEnumGroups } from '../../ngxs/app/app.state.model';
import {
  WorkCalculationitem,
  WorkContact,
  WorkElectricalMeasurement,
  WorkElectricalMeasurementsService,
  WorkItemsForProjectDto,
  WorkMyService,
  WorkProject,
  WorkProjectrevenue,
  WorkProjectrevenuesService,
  WorkProjectsService,
  WorkTask,
} from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project',
  templateUrl: './ax-project.component.html',
  styleUrls: ['./ax-project.component.scss'],
})
export class AxProjectComponent implements OnInit {
  @Input() project: WorkProject;
  @Input() items: WorkItemsForProjectDto;
  @Input() contact: WorkContact;
  @Input() isInternalView = false;
  @Output() openItemDetailsForCalculationitem: EventEmitter<WorkCalculationitem> = new EventEmitter<WorkCalculationitem>();
  public appointments: WorkTask[];
  public calculationitems: WorkCalculationitem[] = [];
  public projectrevenues: WorkProjectrevenue[];
  public electricalMeasurements: WorkElectricalMeasurement[];
  public accordionStates: any = {};
  public roles: Observable<string[]> = this.store.select(AppState.roles);
  public isDSProject = false;
  public isAbStufeKundenberater = false;

  constructor(
    private axProjectsService: WorkProjectsService,
    private axProjectrevenuesService: WorkProjectrevenuesService,
    private axElectricalMeasurementsService: WorkElectricalMeasurementsService,
    private axMyService: WorkMyService,
    private modalController: ModalController,
    private router: Router,
    private store: Store,
  ) {
  }

  ngOnInit() {
    if (this.isInternalView) {
      this.axProjectsService.projectsV1ControllerGetAppointmentsForProject({ id: this.project.id })
        .subscribe(appointments => this.appointments = appointments);
      this.axProjectsService.projectsV1ControllerGetCalculationitemsForProject({ id: this.project.id })
        .subscribe(calculationitems => this.calculationitems = calculationitems);
      this.axProjectrevenuesService.projectrevenuesV1ControllerFindByProjectId({ projectId: this.project.id })
        .subscribe(projectrevenues => this.projectrevenues = projectrevenues);
      this.axElectricalMeasurementsService.electricalMeasurementsV1ControllerFindAllForProject({ projectId: this.project.id })
        .subscribe(electricalMeasurements => this.electricalMeasurements = electricalMeasurements);

      try {
        this.isDSProject = this.project.container.containertypeId === 2;
      } catch (nothing) {
      }

      this.roles.subscribe(roles => {
        const isAbStufeKundenberater = () =>
          roles.some((role: RolesEnum) =>
            RolesEnumGroups.ab_stufe_kundenberater.includes(role),
          );
        this.isAbStufeKundenberater = isAbStufeKundenberater();
      });
    } else {
      this.axMyService.myProjectsV1ControllerGetProjectrevenuesForProject({ id: this.project.id })
        .subscribe(projectrevenues => this.projectrevenues = projectrevenues);
    }
  }

  goToPhotosUpload() {
    this.router.navigateByUrl(`/global/upload-photos-to-project/${this.project.id}`).then();
  }

  async openElectricalMeasurementDetail(electricalMeasurement: WorkElectricalMeasurement) {
    const modal = await this.modalController.create({
      component: CreateElectricalMeasurementDetailPage,
      componentProps: {
        electricalMeasurement,
        readonly: true,
      },
    });
    modal.onDidDismiss().then((overlayEventDetail) => {
      if (overlayEventDetail.data) {
        electricalMeasurement = overlayEventDetail.data;
      }
      LoggerService.LOG(this, 'electricalMeasurement.active', electricalMeasurement.active);
      if (!electricalMeasurement.active) {
        const index = this.electricalMeasurements.findIndex(em => em.id === electricalMeasurement.id);
        LoggerService.LOG(this, 'index', index);
        if (index > -1) {
          this.electricalMeasurements.splice(index, 1);
        }
      }
    });
    await modal.present();
  }
}
